import "./polyfills/browser.polyfills";
import { enableProdMode, NgZone, EventEmitter } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.browser.module";
import { anychartDark } from "./app/components/achart/anychart.dakrk.theme";

// // Enable either Hot Module Reloading or production mode
if (module.hot && module.hot.accept && module.hot.dispose) {
    module.hot.accept();
    module.hot.dispose(() => {
        // Before restarting the app, we create a new root element and dispose the old one
        const oldRootElem = document.querySelector("app");
        const newRootElem = document.createElement("app");
        oldRootElem!.parentNode!.insertBefore(newRootElem, oldRootElem);
        modulePromise
            .then(appModule => {
                appModule.destroy();
                if (oldRootElem) {
                    oldRootElem.parentNode!.removeChild(oldRootElem);
                }
            })
            .catch(e => {
                console.error(e);
            });
    });
} else {
    enableProdMode();
    console.log = (message?: any, ...optionalParams: any[]) => {};
}

//enableProdMode();
//console.log = (message?: any, ...optionalParams: any[]) => {};

(<any>window).Zone = {
    assertZonePatched() {},
    current: {
        fork(a: any) {}
    }
};

NgZone.isInAngularZone = function() {
    return true;
};

NgZone.assertNotInAngularZone = function() {};
NgZone.assertInAngularZone = function() {};

export class MyZone extends NgZone {
    current: any = {
        fork(a: any) {}
    };
    constructor() {
        super({});
        (<any>window).Zone = this;
        this.current = this;
    }
    get(a: any) {
        return true;
    }

    readonly hasPendingMicrotasks: boolean = false;
    readonly hasPendingMacrotasks: boolean = false;
    readonly isStable: boolean = true;
    readonly onUnstable: EventEmitter<any> = new EventEmitter();
    readonly onMicrotaskEmpty: EventEmitter<any> = new EventEmitter();
    readonly onStable: EventEmitter<any> = new EventEmitter();
    readonly onError: EventEmitter<any> = new EventEmitter();

    run(fn: () => any): any {
        return fn();
    }

    runGuarded(fn: () => any): any {
        return fn();
    }

    runOutsideAngular(fn: () => any): any {
        (window as any)._runOutsideAngular = true;
        try {
            var res = fn();
            return res;
        } catch (e) {
            console.error(e);
        } finally {
            (window as any)._runOutsideAngular = false;
        }
    }

    runTask<T>(fn: () => any): any {
        return fn();
    }
    _inner: any = {
        fork(a: any) {}
    };
}

const modulePromise = platformBrowserDynamic().bootstrapModule(AppModule, {
    ngZone: new MyZone() //'noop'
});

modulePromise
    .then(() => {
        anychartDark();
    })
    .catch(e => {
        console.error(e);
    });
